import styled, { css } from "styled-components";

export const StyledEmptyScreen = styled.div`
  width: 100%;
  height: ${({ $height }) => $height && $height};
  display: flex;
  align-items: center;
  justify-content: center;

  .empty-screen-holder {
    width: 450px;
  }

  .empty-screen-content {
    border-radius: 25px;
    overflow: hidden;
    position: relative;
    padding: 10px;
    margin: 0 0 30px;

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: 25px;
      background:
        radial-gradient(circle at 30% 30%, #b74bff 0%, transparent 50%),
        radial-gradient(circle at 70% 40%, #2783ec 0%, transparent 50%),
        radial-gradient(circle at 50% 80%, #1dc35f 0%, transparent 50%);
      filter: blur(80px);
      background-size: 400% 400%;
      animation: gradient 15s ease infinite;
    }

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }

    .empty-screen-content-inner {
      position: relative;
      z-index: 2;
      background: var(--white);
      padding: 20px;
      border-radius: 18px;
      overflow: hidden;
      box-shadow: 0px -3.03px 2.02px -2.02px #00000033 inset;
      box-shadow: 0px 4.04px 13.14px 0px #0000001a;

      .head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 15px;
        margin: 0 0 10px;

        .img-holder {
          width: 50px;
          height: 50px;
        }
        .text-holder {
          flex-grow: 1;
          h4 {
            margin: 0 0 5px;
          }
          .head-text {
            display: block;
            font-size: 14px;
            line-height: 18px;
            /* color: #7F8594; */
          }
        }

        .tag {
          display: block;
          min-width: 90px;
          text-align: center;
          font-size: 13px;
          line-height: 16px;
          font-weight: 600;
          color: #317bff;
          position: relative;
          border-radius: 50px;
          padding: 5px 12px 5px 24px;
          background: rgba(49, 123, 255, 0.1);

          &::before {
            content: "";
            position: absolute;
            left: 12px;
            top: 50%;
            transform: translateY(-50%);
            width: 6px;
            height: 6px;
            border-radius: 50px;
            background: #317bff;
          }
        }
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .bar-holder {
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .last-heading,
  .description {
    text-align: center;
  }

    .description {
      margin: 0 0 16px;
    }

  .btn-holder {
    display: flex;
    justify-content: center;
  }

  .bar-holder,
  .unibox-empty-screen-holder {
    padding: 20px 12px;
    border: 1px solid #dddddd;
    border-radius: 18px;
  }
`;

export const StyledDataBar = styled.div`
  width: ${({ width }) => (width ? width : "100%")};
  height: 8px;
  border-radius: 6px;
  background: ${({ background }) => (background ? background : "#cfd4dc")};
  animation: floatBars 3s ease-in-out infinite;
  margin-left: ${({ alignRight }) => (alignRight ? "auto" : "0")};

  &:not(:last-child) {
    margin-bottom: ${({ marginBottom }) =>
    marginBottom ? marginBottom : "14px"};
  }

  @keyframes floatBars {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-4px);
    }
    100% {
      transform: translateY(0px);
    }
  }
`;

export const StyledUniboxEmptyScreen = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  &:not(:last-child) {
    margin: 0 0 20px;
  }

  ${({ alignRight }) =>
    alignRight &&
    css`
      flex-direction: row-reverse;
    `};

  .img-holder {
    width: 40px;
    height: 40px;
  }
`;

export const StyledDomainsEmptyScreen = styled.div`
  padding: ${({ $padding }) => $padding ? $padding : "35px 5px"} ;

  .img-holder {
    width: 100%;
  }
`;

export const StyledEmptyCampaignScreen = styled.div`
  border: 1px solid #dddddd;
  border-radius: 18px;

  .top-bars {
    padding: 16px 20px 10px;
  }

  .campaign-img-bars-holder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 20px 12px;
  }
`;


